import { useState } from 'react'
import { FiRefreshCw, FiZap } from 'react-icons/fi'

import { Button } from '~/components/Button'
import { Modal } from '~/components/Modal'
import { app_version } from '~/utils/version'

type Props = {
  latestVersion: string
  releaseNotes: string[]
  releasedAt: string
}

async function clearCacheAndReload() {
  if ('caches' in window) {
    const keys = await caches.keys()
    await Promise.all(keys.map((key) => caches.delete(key)))
  }
  window.location.href = `${window.location.origin}?v=${Date.now()}`
}

function isNewerVersion(latest: string, current: string): boolean {
  const [lMaj, lMin, lPat] = latest.split('.').map(Number)
  const [cMaj, cMin, cPat] = current.split('.').map(Number)
  if (lMaj !== cMaj) return lMaj > cMaj
  if (lMin !== cMin) return lMin > cMin
  return lPat > cPat
}

export const UpdateModal: React.FC<Props> = ({
  latestVersion,
  releaseNotes,
  releasedAt,
}) => {
  const isOutdated = isNewerVersion(latestVersion, app_version)
  const [visible] = useState(isOutdated)

  const formattedDate = new Date(releasedAt).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  return (
    <Modal visible={visible}>
      <div className='flex flex-col gap-6'>
        <div className='flex items-center gap-3'>
          <div className='p-2 bg-gpa-blue-50 rounded-lg text-gpa-blue-500'>
            <FiZap size={22} />
          </div>
          <div>
            <h2 className='text-xl font-semibold'>Nova versão disponível</h2>
            <p className='text-sm text-slate-500'>
              v{latestVersion} · {formattedDate}
            </p>
          </div>
        </div>

        <ul className='bg-slate-50 rounded-xl p-4 flex flex-col gap-2'>
          {releaseNotes.map((note, i) => (
            <li key={i} className='flex items-start gap-2 text-sm text-slate-700'>
              <span className='text-gpa-blue-500 mt-0.5'>•</span>
              {note}
            </li>
          ))}
        </ul>

        <p className='text-sm text-slate-500'>
          Sua versão atual: <span className='font-medium'>v{app_version}</span>
        </p>

        <Button
          className='w-full flex items-center justify-center gap-2'
          onClick={clearCacheAndReload}
        >
          <FiRefreshCw size={16} />
          Atualizar agora
        </Button>
      </div>
    </Modal>
  )
}
